import React, { Component } from 'react';
import axios from 'axios';
import config from '../../../../config';
import MenuItem from './MenuItem';
import General from './tabs/General';
import Account from './tabs/Account';
import Notifications from './tabs/Notifications';
import Billing from './tabs/Billing';

export default class Index extends Component {
    state = {
        menu : [
            {
                link: '#general',
                label: 'General'
            },
            {
                link: '#account',
                label: 'Account'
            },
            {
                link: '#billing',
                label: 'Billing'
            },
            {
                link: '#notifications',
                label: 'Notifications'
            }
        ],
        settings: []
    };

    getSettings = () => {
        let url = `${config.apiUrl}settings`;

        axios.get(url).then((res) => {
            this.setState({
                settings: res.data.data
            });
        }).catch((error) => {
            console.log(error);
        });
    };

    getSettingsForTenant = () => {
        let url = `${config.apiUrl}settings`;

        axios.get(url).then((res) => {
            this.mapSettingsParameters(res.data.data);
        }).catch((error) => {
            console.log(error);
        });
    };

    mapSettingsParameters = (settings) => {
        for (let setting of settings) {
            if (setting.type !== 'general') {
                continue;
            }

            let data = {};
            data[setting.param] = setting.value;

            if (setting.param === 'small_logo') {
                sessionStorage.setItem('small_logo', setting.value);
            }

            this.setState(data);
        }
    };

    componentDidMount() {
        this.getSettings();
    }

    render() {
        return (
            <div className="page-content">
                <div className="row">
                    <div className="col-md-12">
                        <div className="settings-content">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="portlet light">
                                        <div className="portlet-title tabbable-line">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="caption">
                                                        <i className="icon-settings font-blue" />
                                                        <span className="caption-subject font-blue sbold uppercase">Application Settings</span>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 tabbable-line">
                                                    <ul className="nav nav-tabs nav-justified">
                                                        {this.state.menu.map((item, i) => {
                                                            return <MenuItem {...item} key={i} index={i} />
                                                        })}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="portlet-body">
                                            <div className="tab-content">

                                                <div className="tab-pane active" id="general">
                                                    <General settings={this.state.settings} {...this.props}
                                                             getSettings={this.getSettings}
                                                             getSettingsForTenant={this.getSettingsForTenant} />
                                                </div>

                                                <div className="tab-pane" id="account">
                                                    <Account settings={this.state.settings} {...this.props}
                                                             getSettings={this.getSettings}
                                                             getSettingsForTenant={this.getSettingsForTenant} />
                                                </div>

                                                <div className="tab-pane" id="billing">
                                                    <Billing settings={this.state.settings} {...this.props}
                                                             getSettings={this.getSettings}
                                                             getSettingsForTenant={this.getSettingsForTenant} />
                                                </div>

                                                <div className="tab-pane" id="notifications">
                                                    <Notifications settings={this.state.settings} {...this.props}
                                                                   getSettings={this.getSettings}
                                                                   getSettingsForTenant={this.getSettingsForTenant} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/management/settings/Index.js
 **/